<template>

  <div>

    <creating
      v-if="creating"
      height="50px" />

    <div v-if="!creating">
      
      <div v-if="activities.length">
        <ul class="list-group feedlist">
          <li
            class="list-group-item"
            v-for="(activity, index) in activities"
            :key="index">

            <!--email-->
            <div
              v-if="activity.type === 'email'"
              class="feed-item">
              <div class="feed-icon">
                <i class="fas fa-envelope" />
              </div>
              <candidate-feed-email-item
                :activity="activity">
                </candidate-feed-email-item>
            </div>

            <!--note-->
            <div
              v-if="activity.type === 'note'"
              class="feed-item">
              <div class="feed-icon text-warning">
                <i class="fas fa-comment-alt" />
              </div>
              <candidate-feed-note-item
                :activity="activity">
                </candidate-feed-note-item>      
            </div>

            <!--evaluation-->
            <div
              v-if="activity.type === 'evaluation'"
              class="feed-item">
              <div class="feed-icon">
                <i class="fas fa-thumbs-up" />
                <i class="fas fa-thumbs-down" />
              </div>
              <candidate-feed-evaluation-item
                :activity="activity">
                </candidate-feed-evaluation-item>
            </div>

            <!--task-->
            <div
              v-if="activity.type === 'task'"
              class="feed-item">
              <div class="feed-icon">
                <i class="far fa-check-square" />
              </div>
              <candidate-feed-task-item
                :activity="activity">
                </candidate-feed-task-item>
            </div>

            <!--move-->
            <div
              v-if="activity.type === 'move'"
              class="feed-item">
              <div class="feed-icon text-primary">
                <i class="fas fa-arrow-alt-circle-right" />
              </div>
              <candidate-feed-move-item
                :activity="activity">
                </candidate-feed-move-item>
            </div>

            <!--qualification-->
            <div
              v-if="activity.type === 'qualification'"
              class="feed-item">
              <div
                class="feed-icon"
                :class="activity.qualification.status==='disqualified' ? 'text-danger' : 'text-success'">
                <i class="fas fa-ban" v-if="activity.qualification.status==='disqualified'" />
                <i class="fas fa-redo-alt" v-if="activity.qualification.status==='qualified'" />
              </div>
              <candidate-feed-qualification-item
                :activity="activity">
                </candidate-feed-qualification-item>
            </div>

            <!--meetinsight-->
            <div
              v-if="activity.type === 'meetinsight'"
              class="feed-item">
              <div class="feed-icon">
                <i class="fa-solid fa-people-arrows"></i>
              </div>
              <candidate-feed-meetinsight-item
                :activity="activity">
                </candidate-feed-meetinsight-item>
            </div>

            <!--event-->
            <div
              v-if="activity.type === 'event'"
              class="feed-item">
              <div class="feed-icon">
                <i class="far fa-calendar-alt" />
              </div>
              <candidate-feed-event-item
                :activity="activity">
                </candidate-feed-event-item>
            </div>

            <!--questionnaire-->
            <div
              v-if="activity.type === 'questionnaire'"
              class="feed-item">
              <div class="feed-icon">
                <i class="fas fa-clipboard" />
              </div>
              <candidate-feed-questionnaire-item
                :activity="activity">
                </candidate-feed-questionnaire-item>
            </div>

            <!--intervideo-->
            <div
              v-if="activity.type === 'intervideo'"
              class="feed-item">
              <div class="feed-icon">
                <i class="fas fa-video" />
              </div>
              <candidate-feed-intervideo-item
                :activity="activity">
                </candidate-feed-intervideo-item>
            </div>
          </li>
        </ul>

        <div 
          v-if="paginate.page < paginate.pages"
          :class="{'box-loading': loading}">
          <button 
            type="button" 
            class="btn btn-light btn-block" 
            @click="loadActivities(paginate.page + 1)">
            {{ $t('Load more') }}
            </button>
        </div>
      </div>

      <no-results
        v-if="!activities.length"
        class="my-3">
        {{ $t('There are no items') }}
        </no-results>

    </div>
   
  </div>

</template>

<script>
import CandidateFeedNoteItem from './CandidateFeedNoteItem'
import CandidateFeedEvaluationItem from './CandidateFeedEvaluationItem'
import CandidateFeedTaskItem from './CandidateFeedTaskItem'
import CandidateFeedMoveItem from './CandidateFeedMoveItem'
import CandidateFeedQualificationItem from './CandidateFeedQualificationItem'
import CandidateFeedMeetinsightItem from './CandidateFeedMeetinsightItem'
import CandidateFeedEmailItem from './CandidateFeedEmailItem'
import CandidateFeedEventItem from './CandidateFeedEventItem'
import CandidateFeedQuestionnaireItem from './CandidateFeedQuestionnaireItem'
import CandidateFeedIntervideoItem from './CandidateFeedIntervideoItem'

export default {
  name: 'CandidateFeed',
  components: {
    CandidateFeedNoteItem,
    CandidateFeedEvaluationItem,
    CandidateFeedTaskItem,
    CandidateFeedMoveItem,
    CandidateFeedQualificationItem,
    CandidateFeedMeetinsightItem,
    CandidateFeedEmailItem,
    CandidateFeedEventItem,
    CandidateFeedQuestionnaireItem,
    CandidateFeedIntervideoItem
  },
  props: [
    'activityType'
  ],
  data () {
    return {
      creating: true,
      loading: true
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    activities () {
      return this.$store.getters.getActivities
    },
    paginate () {
      return this.$store.getters.getActivitiesPaginate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    onlyThisJob () {
      return this.$store.getters.getCandidateOnlyThisJob
    }
  },
  watch: {
    'selectedJob._id': function (val) {
      this.loadActivities(1)
    },
    onlyThisJob: function (val) {
      this.loadActivities(1)
    }
  },
  created () {
    this.loadActivities(1)
  },
  methods: {
    loadActivities (page) {
      this.loading = true

      let params = {
        candidate: this.candidate._id,
        type: this.activityType,
        sort: '-created_at',
        limit: this.$default.limit,
        page: page
      }

      if (this.selectedJob && this.onlyThisJob) {
        params.job = this.selectedJob._id
      }

      this.$store
      .dispatch(page === 1 ? 'selectActivities' : 'selectMoreActivities', params)
      .then((result) => {
        this.loading = this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeed.vue